<template>
  <v-select
    ref="tableSelect"
    class="table-select pt-1"
    :class="{ 'table-select-empty': value.length <= 0 }"
    clearable
    dense
    hide-details
    multiple
    single-line
    :items="items"
    :item-text="itemText"
    :item-value="itemValue"
    :menu-props="{ offsetY: true }"
    :value="value"
    @input="$emit('input', $event)"
    @click:clear="onSelectClear"
  >
    <template #selection></template>
    <template #prepend-inner v-if="value.length > 0">
      <span class="table-select-text active-table-select-text"> {{ label }} </span>
    </template>
    <template #prepend-inner v-else-if="value.length === 0">
      <span class="table-select-text inactive-table-select-text"> {{ label }} </span>
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'TableSelect',
  props: {
    items: {
      type: Array,
      required: true,
    },
    itemText: {
      type: String,
      default: 'text',
    },
    itemValue: {
      type: String,
      default: 'value',
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onSelectClear() {
      this.$refs.tableSelect.blur();
    },
  },
};
</script>
<style lang="scss" scoped>
.v-input {
  width: auto;
}
.v-label {
  position: static !important;
}
.table-select.table-select-empty {
  background-color: rgba(152, 152, 152, 0.12);
  ::v-deep .v-input__icon .v-icon {
    color: grey !important;
  }
}
.table-select:not(.table-select-empty) {
  background-color: rgba(26, 115, 232, 0.1);
  ::v-deep .v-input__icon .v-icon {
    color: rgba(26, 115, 232) !important;
    padding-bottom: 5px;
  }
}
.table-select {
  border-radius: 4px;
  padding: 0 8px;
  margin: 0 8px;
  .table-select-text {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 13px;
    padding-top: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .active-table-select-text {
    color: rgba(26, 115, 232);
  }
  .inactive-table-select-text {
    color: grey;
  }
  ::v-deep .v-label {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 13px;
  }
  ::v-deep .v-select__selection {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 13px;
  }
  ::v-deep .v-input__icon .v-icon {
    padding-bottom: 5px;
  }
  ::v-deep .v-input__control .v-input__slot .v-select__slot .v-label {
    position: static !important;
    right: 0 !important;
  }
  ::v-deep .v-input__control .v-input__slot .v-select__slot .v-select__selections {
    width: 0;
  }
}
::v-deep .v-list-item {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 11px !important;
  line-height: 20px;
  min-height: 30px;
  padding: 0 8px;
}
::v-deep .v-input__slot::after {
  display: none;
}
::v-deep .v-input__slot::before {
  display: none;
}
.v-select--is-menu-active {
  ::v-deep .v-icon {
    padding-bottom: 0px !important;
  }
}
::v-deep .v-list-item__title {
  text-align: left;
}
</style>
